import { render, staticRenderFns } from "./LoaderDialog.vue?vue&type=template&id=27b97436&scoped=true"
import script from "./LoaderDialog.vue?vue&type=script&lang=js"
export * from "./LoaderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b97436",
  null
  
)

export default component.exports